import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DelegationSliderConstants } from '../delegation-slider-constants';
import { DelegationInteractionService } from '../services/delegation-interaction-service';

@Component({
  selector: 'app-delegation-slider',
  templateUrl: './delegation-slider.component.html',
  styleUrls: ['./delegation-slider.component.scss']
})
export class DelegationSliderComponent implements OnInit {

  @Input() isDelegateSliderOpen = false
  @Input() isDelegateSliderOpenedFromDocumentDetailPage = false;
  @Input() documentNumber = '';
  @Output() isDelegateSliderActive = new EventEmitter<boolean>();
  activeTab = 0;
  isLinkedItemsSlider = false;
  linkedItemTabActive=false;
  errorIconClassForTab = '';
  topBarTitle:string = DelegationSliderConstants.DelegationSliderTitle;
  constructor(private delegationInteractionService: DelegationInteractionService) { }

  ngOnInit(): void {
    this.delegationInteractionService.closeAndResetDelegateSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetDelegateSlider(); this.errorIconClassForTab='';}
    })

    this.delegationInteractionService.linkedTabEnabler$.subscribe((isEnabled) => {      
      if(isEnabled) {this.isLinkedItemsSlider = true;}
      else this.isLinkedItemsSlider = false;
    })
    this.delegationInteractionService.errorTabsOnSave$.subscribe((errorTab) => {
      this.showErrorIconForTab(errorTab);
    })
  }

  closeSlider() {
    this.delegationInteractionService.openConfirmationDialog();
  }

  closeAndResetDelegateSlider() {    
    this.isDelegateSliderOpen = false;
    this.isLinkedItemsSlider = false;
    this.isDelegateSliderActive.emit(this.isDelegateSliderOpen);
    this.delegationInteractionService.closeAndResetDelegateSlider$.next(false);
  }
  openCurrentTab(event:any){
    this.activeTab=event;
  }
  ngOnDestroy = () => {
    this.delegationInteractionService.closeAndResetDelegateSlider$.unsubscribe();
  }
  showErrorIconForTab = (errorTab: number) => {
    if (errorTab === 0) {
      this.errorIconClassForTab = 'pi pi-exclamation-triangle';
    } else {
      this.errorIconClassForTab = '';
    }
  }
}
